module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "ach1",
      "title": "808 Conversation Starters For Couples"
    }
  }, [_c('p', {
    staticClass: "centera"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("Let’s say you’re getting a tattoo inked in a prominent place. What does it look like?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("You can have one wish granted. What is it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Mini Quiz")]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("You’re dying for a bowl of breakfast cereal, but after pouring it out, you discover there’s no milk. What to do?")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Eat it dry and crunchy.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Go to the store for milk.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Pour it back in the box and stop off for breakfast somewhere.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("If your clothes send a message about who you are, what are yours saying?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How would you describe your relationship with your mother? And your father?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you could invite any living person to share a private spa weekend with you, who would it be and why?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("For you, having two relationships going on at once would be:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Out of the question.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Confusing. You’d feel emotionally torn and drained.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Cool, as long as everyone felt comfortable with the situation.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Is fame something you want? If yes, how would you like to be known? If no, why not?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Who’s your BFF? What are his or her qualities?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("You open your door and find a super-cute kitten sitting on the welcome mat. What do you do?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Describe your best night ever.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("You win a plane ticket to go anywhere in the world. Where do you want to land? What makes it so appealing?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Which actor gets major props from you? Why?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("What did you write in your most embarrassing text (or email)?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Heavy alert: How do you want to be remembered after you die?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Mini Quiz")]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("If you could add a room onto your home, would it be a:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Greenhouse, with roses, orchids, and other plants that grow all year round.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Giant bathroom, complete with enormous tub, multi-headed shower, and a steam room or sauna.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Gym, with a treadmill, weights, stationary cycle, and yoga area.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Which do you enjoy more, giving or receiving? Why?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Describe the selfie you would love to take.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you share your most humiliating childhood memory?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("What do you respect most about your partner?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Which turns you on the most?")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Super smarts")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Sense of humor")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Strong character")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What do you like least?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Belt out lyrics to your favorite song.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("When was the last time you broke down and had a real weep fest? What was it about?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What do you most regret in your life?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Mini Quiz")]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Which female newscaster would you want to interview you?:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Diane Sawyer")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Katie Couric")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Meghan Kelly")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Name five things in your life that fill you with gratitude.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Ask your partner to help solve a problem you’re having with a colleague or friend.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("What are the top-six must-dos on your bucket list?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you were hoping for a promotion but a coworker got it instead, what would you do?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Mini Quiz")]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("If you chose a piece of candy from a box of chocolates, took a nibble, and didn’t like it, would you:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Put it back and choose another one.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Throw it away and count your blessings that you saved the unappetizing calories.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Keep eating until you find one that tastes delish.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s the most important piece of advice you ever received?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you inherited $500,000, what would you do with it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Which of these is the furthest from your comfort zone?")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Leading a 6 a.m. yoga rave for a thousand yogis.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Accompanying two dozen toddlers on their preschool field trip.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Catering a brunch for 25 top chefs.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("What does “unconditional love” mean to you?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Tell me about a time you lost something that was really valuable to you. What did you tell yourself to get over it? Or are you still feeling bad about your loss?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Mini Quiz")]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("A friend’s partner flirts with you. You consider this:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" A compliment.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Possible trouble ahead.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" The end of a friendship.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("Why do you think so many bad things happen in our world?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Which super hero would you want to be? Describe his or her power and why you desire it.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Why do you think you were born?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Name three things about life you’re certain about.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("If you had to slip into a time machine that only went backward, what year would you go to and why?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you believe in ghosts? Why or why not?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you name at least five things we share in common?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you could hurt someone’s reputation online, where would you aim your poison arrow?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("What’s the most erotic dream you ever had?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Stare into each other’s eyes silently for at least three minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you had to either never binge watch TV again or never set foot in a movie theater, which would you choose to give up?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s your hugest worry?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("When you encounter an obstacle, you’re most likely to:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Weigh whether you’re chasing the right goal.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Decide it’s best to change your approach.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Stay on course and work harder to solve the problem.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you feel like you’re the same person you were ten years ago? In what ways are you the same? In what ways are you different?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you could change a decision you made, what would it be?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("Do it! Cuddle silently for five minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What animal do you most resemble when you’re having sex?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you rather live in a very messy and relaxed house or an uncluttered and divinely decorated one?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s your best time of day and what are you usually doing during it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Which statement best reflects your feelings about physical attraction?")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" It can be turned on and off like a faucet.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" It’s pure, uncontrollable magnetism.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" It often requires careful cultivation.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What would be the worst job in the world for you and what makes it so wrong?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Is there anything that someone can say in this moment to make you feel better about yourself?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("Do you believe in miracles? Why or why not?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Has something good happened to a friend and instead of feeling happy for him or her you felt envious? What do you think that was about?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you believe reincarnation is for real? Why or why not?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What was a time in your life when your self-esteem was lower than a blade of freshly mowed grass?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("At parties, your favorite thing to do is:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Hang with lots of different people.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Have an intimate one-on-one conversation.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Happily sit back by yourself and observe.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you get to airports really early for a flight or take your chances and guesstimate the least amount of waiting time? What’s your reasoning?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you believe in soul mates, two people destined to be together?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you knew you were going to die in a year, what would you be doing differently?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Which of these statements most closely speaks your truth?")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" When one door closes, another opens.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" You can’t open the door without the golden key—and not everyone has it.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Some doors are better left locked.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever been scammed? If so, how’d it go down? If not, how’d you suss it out?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("Do you believe in love at first sight?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you have an enemy? What caused the rift? And do you have regrets about the way it was handled?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Sit across from one another, close eyes, touch foreheads, and take twenty deep breaths in unison.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you think animals are more loving than people?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "title": "26"
    }
  }, [_vm._v("Are you comfortable with public display of affection (PDA)? What’s cool but what’s way too embarrassing?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Are you still in touch with your exes? If not, why not?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you think happiness can be bought?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What would outrage you so much you would take to the streets to protest? Or if you’ve already done so, what was the cause?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "title": "27"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Do you think true happiness is:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Something we have to work at to achieve.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Why we’re alive.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" An illusion.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you had a free hour, what would you probably do with it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The last time you had a major decision to make, did you decide quickly or agonize over the alternatives?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "title": "28"
    }
  }, [_vm._v("Do you believe in fate or do you think we create our future?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you rather see a thriller flick, romantic comedy, or action movie? What do you consider a classic film in your favorite genre? Where did you see it? How did you react during and after viewing?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s your favorite season and what do you like best about it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you rather diet or work out?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "title": "29"
    }
  }, [_vm._v("Do you consider yourself more of an introvert or extrovert?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you found a wallet with cash and credit cards someone had left in a taxi you’re in, what would you do?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What do you consider a total no-no in a relationship?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Whisper a sweet or sexy sentiment into your partner’s ear.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_vm._v("Are you an animal lover? Or do you feel ambivalent about them?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you rather spend the afternoon walking through the countryside or the streets of Paris? Why?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Mini Quiz")]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("If your horoscope suggested you avoid making important decisions today, you would:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Put them off until tomorrow.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Ponder those decisions a little more carefully.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Ignore the warning.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "title": "31"
    }
  }, [_vm._v("When was the last time you told a lie? How come you felt the need to be deceitful?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Fourth of July, Christmas, Thanksgiving, Valentine’s Day—which is your favorite, and what do you dig most about it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("When did you lose your virginity? Was it a good experience, not so hot, or something you’d rather forget?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Has your taste in music changed over the years? What did you enjoy in the past and what are you into now?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "title": "32"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Let’s say you run into your sister’s husband arm-in-arm with another woman. You:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Phone your sister pronto!")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Pull him aside and ask what the heck is going on!")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Stay out of it.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How do you roll? Super planner or sucker for spontaneity?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you consider yourself religious, spiritual, or a non-believer? Has it always been this way? If not, what changed your belief system?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "title": "33"
    }
  }, [_vm._v("What do you think about porn?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Blindfold your partner and lead him or her around the house using just these verbal instructions: forward, back, left, right, go, stop.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Who have you lost touch with that you think about fairly regularly?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("When you need help or advice, whom are you likely to ask?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  }, [_vm._v("Who’s the luckiest person you know and why?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you say you usually trust your gut reaction or are you more likely to use your intellect?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s the weirdest photo you’ve ever snapped with your phone? Did you delete or post it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Bloody hell! Are you into vampire movies? Why or why not?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "title": "35"
    }
  }, [_vm._v("What did you buy online that you really regret?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s your take on gluten-free diets? For real or all hype?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What are the six smartphone apps you just can’t do without?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What do you think about those whopper Wall Street bonuses? Should there be a cap on them or do you think capitalism should be free to fly?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "title": "36"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("If you were suddenly a billionaire and swamped with requests for donations, what would you do?")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Pick one favorite charity and gladly write a big, fat check.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Set up a foundation so others can also contribute.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Make anonymous donations to several different charities.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you rely on online reviews before making reservations at a hotel or restaurant or before buying a product? Why or why not?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Give your partner a hand massage.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37",
      "title": "37"
    }
  }, [_vm._v("If an energy company were planning on building a wind farm on property with a pristine view, would you be for or against it?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you say you are more cautious than carefree? For example, do you back up your computer files?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What about juicing? A good idea or bogus? What makes you come to this conclusion?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever been cyber-stalked? Or have you ever cyber-stalked someone else?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_38",
      "title": "38"
    }
  }, [_vm._v("Let’s say you’re disconnected electronically. How long do you think you could go before freaking out and searching for a place that has a connection?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you believe there’s power in prayer? Why or why not?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Imagine our world were run by women. How would it be different than it is today?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you were to add one more commandment to the list of ten, what would it be?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_39",
      "title": "39"
    }
  }, [_vm._v("Can you think of a cause that would be worth dying for?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever stolen? Describe one incident.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Is there such a thing as too many tattoos or piercings?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you think pot should be legalized? Why or why not?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40",
      "title": "40"
    }
  }, [_vm._v("If you ran into a celebrity, would you ask for a selfie with them? If yes, would you post it somewhere? If not, what’s your reasoning for not making the request?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Where do you like to people watch?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Mini Quiz")]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("If you had a great idea but others resisted it, would you:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Offer another equally cool idea.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Just go along with the group.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Figure out a way to reframe your same idea.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_41",
      "title": "41"
    }
  }, [_vm._v("What’s something you really enjoyed doing as a kid but haven’t done in years?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Put on your favorite slow tune and dance in each other’s arms.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What object in your childhood bedroom do you wish you had now?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you have any desire to climb Mt. Everest? What do you imagine would be your greatest challenge?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_42",
      "title": "42"
    }
  }, [_vm._v("What is the most powerful lesson your mother taught you?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How often do you look at your email and texts? Do you check, for example, as soon as you wake up? Would you like to stop checking so often?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How do you feel about all the surveillance cameras in public spaces?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you think the earth is doomed? What are some ways you do and don’t try to protect the environment?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_43",
      "title": "43"
    }
  }, [_vm._v("Do you check food labels? What do you look for first: Calories? Carbs? Organic? GMO? If you’re not concerned, what’s your food philosophy?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s the one question you’re hoping won’t be asked? What are you dying to talk about instead?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you think you’re a better judge of character or beauty? What are your qualifications?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_44",
      "title": "44"
    }
  }, [_vm._v("Do it! Take the trust fall. Stand up tall and stretch your arms out in front of you. Your partner is behind ready to catch you when you fall backward.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("When no one else is around, what kind of music do you put on?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What saying would you put on a T-shirt?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Has the threat of terrorism ever kept you from traveling to another city or country or from going to a public event?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_45",
      "title": "45"
    }
  }, [_vm._v("Most of us have a phobia of some kind. What’s yours and how do you deal with it?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Which actor would you love to play opposite you?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Mini Quiz")]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("In family photos are you usually:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Not there, since you’re the one taking the picture.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Wherever there’s an open spot.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Smiling center stage.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_46",
      "title": "46"
    }
  }, [_vm._v("How do you feel about the expression, “It’s better to have loved and lost than never to have loved at all”?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you sing karaoke? What song would be your first choice?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If your good friend were acting cruelly to her partner, would you intervene? What if your friend’s partner was disrespecting your friend?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you believe love conquers all?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_47",
      "title": "47"
    }
  }, [_vm._v("If there were one thing you could improve about yourself to make you a better friend, what would it be?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you say you had a pretty easygoing childhood?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If your beloved pet was sick and a treatment (which might, or might not, save him) would mean you had to borrow $5,000 dollars, would you do it? Or let him go? What’s your reasoning?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_48",
      "title": "48"
    }
  }, [_vm._v("Do you feel like you have a “calling” or are you open to going in wildly different directions?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Walk down the street hand-in-hand.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Mini Quiz")]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("An ex who lives 3,000 miles away phones to say he or she is in town and would like to meet for lunch. Suddenly you feel the old passion return. You:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Meet in some out-of-the-way dive bar and let the heat rise.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Douse yourself with cold water and decline.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Agree to meet but keep it chill to the max.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_49",
      "title": "49"
    }
  }, [_vm._v("What’s the greatest gift anyone could give you?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What would be the title of your autobiography?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What is the biggest misunderstanding you had with a friend and what was done (or not done) to clear it up?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you could activate any object just with your voice, which one would it be?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_50",
      "title": "50"
    }
  }, [_vm._v("Has a child ever taught you a lesson you’ve never forgotten?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How honest would you be (or have you been) when it comes to an online dating profile? What little white lies have you told?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you were only allowed to make one call for help, who would you call?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What was the most memorable dare you ever took? Do you have regrets? Or are you grateful you did it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_51",
      "title": "51"
    }
  }, [_vm._v("What was the best New Year’s Eve celebration you ever had?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What are five things you could do that would improve your life?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you live your life in a different way if you didn’t feel responsible to others? In what ways?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Which late-night talk show would you love to be on?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_52",
      "title": "52"
    }
  }, [_vm._v("Which family member do you most resemble in temperament? In looks? In special talents or interests?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Which "), _c('i', [_vm._v("Jeopardy!")]), _vm._v(" category would you choose first? Which would you try to avoid?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Mini Quiz")]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("If your partner isn’t responding to your hot advances, do you:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Try a different turn-on like a massage or a sexy movie.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Probably just feel rejected and hurt.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Assume your partner must be distracted or tired.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_53",
      "title": "53"
    }
  }, [_vm._v("What is your strangest possession? When did you get it? Would you sell it if someone offered you twice its value?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Looking ahead to the next ten years, what three goals would you like to achieve?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How important are other people when it comes to your happiness?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you describe a place you used to go or hide in when you were a kid? How often did you go there? Why did you choose it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_54",
      "title": "54"
    }
  }, [_vm._v("What’s the funniest comedy you’ve ever seen? Can you recall one or two hilarious scenes?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What do you obsess over?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s a guilty pleasure you only do when you’re alone?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Hug and hold tight.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_55",
      "title": "55"
    }
  }, [_vm._v("What do you remember most about your first kiss?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Who are five people, dead or alive, that you think are totally brilliant?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s the wackiest thing you’ve ever done?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Did you ever lie about what you did for a living, or where you grew up, or where you went to school?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_56",
      "title": "56"
    }
  }, [_vm._v("Do you think you could ever follow a guru? If yes, why? If not, how come?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What would be the plot to a TV sitcom that depicted your daily life?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What are your most annoying habits?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you believe less is more?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_57",
      "title": "57"
    }
  }, [_vm._v("What part of your life do you consider “on hold,” and what needs to happen to change your situation?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you name five people you would choose to live on an island with you? Why did you pick them?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What are three things that you see in the world around you that you find depressing?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you remember the worst rejection you ever felt? What happened?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_58",
      "title": "58"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("You’re visiting Italy but can’t speak the language. What do you do?")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Resort to sign language.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Speak in clear, concise English.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Use a foreign language app.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What chore do you put off most frequently?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever walked out of a movie or a concert? Why?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_59",
      "title": "59"
    }
  }, [_vm._v("What health habit do you wish you could develop?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How has getting older changed you?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s the worst thing an ex has ever done to you?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Did you ever make a fashion faux pas and dress wildly inappropriately for an event?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_60",
      "title": "60"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("If you witnessed a robbery on the street, would you:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Try to help the victim.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Get out of the way quickly.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Call 911.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What do you think would happen if you had to spend two days and two nights alone in a windowless room?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What beliefs would you defend to the end?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_61",
      "title": "61"
    }
  }, [_vm._v("Is there something you wish you started early in life, such as learning to play a musical instrument or practicing a particular sport?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How often have you madly and truly fallen in love? And why wasn’t it forever?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s your idea of hot foreplay?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever had a dream that predicted the future?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_62",
      "title": "62"
    }
  }, [_vm._v("How do you think the planet will look twenty-five years from now?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What kinds of thoughts could wake you from a deep sleep?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you create a clone of yourself? If your answer is yes, why? If your answer is no, why not?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever had a déjà vu experience? Can you describe it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_63",
      "title": "63"
    }
  }, [_vm._v("How did you first learn about “the birds and the bees”?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you have a memory of your parents totally embarrassing you in front of friends? What happened?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Mini Quiz")]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("When making plans for the day, you tend to:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Go with the flow.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Make a list and try to stick to it.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Reprioritize throughout the day and often reconsider plans.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_64",
      "title": "64"
    }
  }, [_vm._v("Would you like to know if you’re at risk for a particular illness even if there were no treatment for it?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you rather live nearer to or farther away from your parents? What’s your reasoning?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you had long-time plans arranged with a friend but something came up unexpectedly and you had to break your date, how would you deal with it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center0"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_65",
      "title": "65"
    }
  }, [_vm._v("If an ATM gave you extra cash, how likely is it that you would report it to the bank?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Cook a meal together.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Are you more of a listener than a talker? Or is it the other way around? Do you think you would benefit by assuming a different dynamic?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What sexual role-plays would turn you on the most?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_66",
      "title": "66"
    }
  }, [_vm._v("Can you tell if someone is lying to you? What clues do you look for to detect dishonesty?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you define the word “mercy”?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What is the most heroic thing you’ve ever done?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Collaborate on an easy art project.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_67",
      "title": "67"
    }
  }, [_vm._v("In what ways do you step up to help make your partner’s life easier? Do you think you should do more? Or do you think you’re doing more than your share?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What would you do if you bumped into your doppelganger on the street?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can a person be too rich?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you rather be a really well-known celebrity or unknown but responsible for saving dozens of lives?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_68",
      "title": "68"
    }
  }, [_vm._v("What would be the hardest thing to turn down even though you know it’s not good for you?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How and where do you like being touched the most?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever witnessed what appeared to be a supernatural event?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What do you think are the best reasons for getting married? The worst?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_69",
      "title": "69"
    }
  }, [_vm._v("How did your mom and dad meet?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What object do you still regret losing either because of its material value or for sentimental reasons?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What does your ideal home look like?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What do you think are five secrets to a long, healthy, and happy life?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you talk about a superstition that you sort of believe in?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_70",
      "title": "70"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("If you reach a two-way stop sign at the same time as another driver, are you more likely to:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Wait and let the other car go.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Obey the rules of the road and yield appropriately.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Try to go through first.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you owned a restaurant what would you call it and what would its specialty be?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Get in a steamy shower together.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_71",
      "title": "71"
    }
  }, [_vm._v("If you believed that being frozen after you died would give you the chance to be brought back to life, but it costs your entire fortune and would leave no money for your heirs, would you do it?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If folks knew the real you—your secret weaknesses, fears, and feelings—would their opinion of you change drastically, a little bit, or not at all? What do you think would freak them out the most?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Which politician do you admire the most and why?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_72",
      "title": "72"
    }
  }, [_vm._v("How do you approach thunder and lightning storms? With excitement or trepidation?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you join a medical study for a treatment that might lengthen your life even though doctors admit they aren’t sure of its side effects?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What do you own that under no circumstances—no way—would you ever agree to loan or share?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What are three things that would definitely trigger your anger?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_73",
      "title": "73"
    }
  }, [_vm._v("Do you have memories of your grandparents?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("When you were a kid, what did you do that got you into the worst trouble?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you were a master builder, what would you create?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How would you describe the universe? Does it have a beginning and an end?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How often do you go to fast-food restaurants?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_74",
      "title": "74"
    }
  }, [_vm._v("If you could get rid of one evil in this world, which would you choose and why?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Send each other hot texts—five words or fewer.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What was your mother’s most annoying habit?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("When would you be likely to drink too much?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_75",
      "title": "75"
    }
  }, [_vm._v("Have you learned something about your partner over the last three months that you didn’t know before? What was it?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If your partner were sad, what would you do to turn the mood around?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you accidentally dropped your partner’s toothbrush in the toilet, retrieved it, and then cleaned it like crazy, would you admit what happened?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s the dumbest thing you ever bought? Did you return it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_76",
      "title": "76"
    }
  }, [_vm._v("Recall the most recent time you apologized. What happened? Was your apology sincere or were you just trying to move on?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How did you meet your best friend?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What bums you out the most about politics?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Which comedian always cracks you up? Do you remember part of the routine?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_77",
      "title": "77"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Faced with the chance to speak in front of a large audience, would you:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Turn it down. It’s your absolute worst nightmare.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Muster up the courage.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Welcome the opportunity.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you had to teach a high school class for an hour, what subject would you choose to teach and how would you begin your lesson?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you believe the devil is real? If not, what are your thoughts about evil? Does it exist?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_78",
      "title": "78"
    }
  }, [_vm._v("When was the last time you really pushed your physical self to the limit? What were you doing and how did you feel before, during, and after?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("In relationships, are you more likely to be the heart-breaker or the heart-broken? Why do you think that is?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you could change your occupation, what would it be? Why aren’t you doing it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s the best surprise you ever got?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_79",
      "title": "79"
    }
  }, [_vm._v("If you could put on an invisible cloak, where would you go and what would you do?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What dish do you love to cook? Why is it your fave, and when and how did you learn it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What do you say to those annoying telemarketers before hanging up?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Read your favorite childhood fairy tale to your partner.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_80",
      "title": "80"
    }
  }, [_vm._v("What are five situations in which you would feel really shy?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What annoys you most about the opposite sex?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Beards: Cool or ridiculous?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Who is the greatest leader of all time? What makes that person so admirable?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What color describes your usual mood?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_81",
      "title": "81"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("The handyman you hired didn’t do the job quite right. How do you feel about telling him to redo it?")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Uncomfortable. You’d rather just do it yourself than ask him to fix it.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Okay. You know how to ask for changes without being a jerk about it.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Fine. Giving directions is second nature to you.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you be willing to give up sex for three months if you knew you would be guaranteed super-hot erotic dreams instead?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What are five of your daily rituals (include things like brushing your teeth)?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_82",
      "title": "82"
    }
  }, [_vm._v("What do you think is the biggest issue facing this country? What, if anything, have you done to try and improve the problem?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever had a long-distance romance? If so, what were the plusses? What were the minuses?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s the closest call you’ve had with death? Describe what happened then and how you feel about it now.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_83",
      "title": "83"
    }
  }, [_vm._v("Describe the time you met someone and immediately felt connected. Are you still in touch? And is the relationship still as intense?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Are you a collector? If so, what do you collect? If not, what do think is the motivation behind accumulating stuff?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Plant a tree together, or if you’re city dwellers, buy a plant and share the responsibility in caring for it.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s your treatment for healing a broken heart?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_84",
      "title": "84"
    }
  }, [_vm._v("Is there something you once did or said that is still bothering you?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s your usual M.O. for breaking off a relationship?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you could dial into a “dream machine” and choose your nocturnal wanderings, what would you want to dream?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Who’s your most eccentric relative? Describe a few of his or her antics.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_85",
      "title": "85"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Is it more important to be:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Honest.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Kind.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Correct.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Nature or nurture? What do you think?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you name five unforgivable actions?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you lend friends money?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_86",
      "title": "86"
    }
  }, [_vm._v("During what period in your life (childhood, high school, college, adulthood) did you meet most of your closest friends?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What was the biggest news event in your life so far? Where were you when you heard about it, or did you experience it first-hand?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Share your favorite joke.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What do you think of people who spend much of their day working on their laptops while sitting in a café?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_87",
      "title": "87"
    }
  }, [_vm._v("When you come up against rules that you personally feel are ridiculous or unfair, do you stick to them anyway?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you name five everyday things that make you happy?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever tracked down an old friend online? What happened after you connected?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you shop only when you need something or do you think of it as retail therapy?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_88",
      "title": "88"
    }
  }, [_vm._v("How long does it take you to truly trust someone? Can you explain?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you say you’re a lucky person? Give examples of why or why not.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you think you could live on a commune with very little privacy, or do you crave your own space and alone time?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_89",
      "title": "89"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Imagine your political party is running an oaf in the next election. You:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Cast your vote for the dummy anyway.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Don’t vote.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Vote for the other candidate.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you say you usually offer more praise than criticism? Is that how you were raised?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What was the most tedious movie you’ve ever seen and what made it so boring?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_90",
      "title": "90"
    }
  }, [_vm._v("What grade (A through F) would you give your parents for their skill set in raising you? Explain.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What news bulletin would make you very happy?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you believe in UFOs or life beyond our own universe?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you name three bad habits you’d like to break?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_91",
      "title": "91"
    }
  }, [_vm._v("What time in your life would you say was the least stressed?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you believe animals have souls or consciousness much like us?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever been ruthlessly teased? If yes, about what? If not, have you ever been a bit of a bully?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you believe we have free will?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_92",
      "title": "92"
    }
  }, [_vm._v("What’s the worst job you ever had? Why was it so terrible?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you start panicking, what do you do or tell yourself to calm down?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you have an easy or a difficult time multi-tasking? Can you stick to only one chore without getting distracted?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Take turns feeding each other from a single bowl of ice cream.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_93",
      "title": "93"
    }
  }, [_vm._v("How do you feel about guns?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you think there are times when stealing is appropriate?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What do you think of Edward Snowden? Hero or enemy of the people? Explain.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you be willing to spend a night alone in a house that people have said was haunted?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_94",
      "title": "94"
    }
  }, [_vm._v("Given your choice, would you rather play a game with someone who was more skilled than you, equally skilled, or less skilled? What’s your reasoning?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How afraid of dying are you? What do you imagine happens?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you were given ten acres of land, where would you want it to be and what would you want to do with it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_95",
      "title": "95"
    }
  }, [_vm._v("What was the worst injury you got as a child or teenager?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you describe a time when you really felt like you were in mortal danger?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Mini Quiz")]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Which of these skin sensations sounds the most scintillating:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Having your body massaged with scented oils.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Jumping into a freezing lake after unwinding in a mega-hot sauna.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Sinking into sun baked beach sand and having the ocean wash over your legs.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_96",
      "title": "96"
    }
  }, [_vm._v("Have you accidentally broken something that was valuable? Did it belong to you or someone else? Did you end up replacing it?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you rather make love in the dark, by candlelight, or in natural light?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What steps do you take to protect your privacy on the Internet?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever read a self-help book that really helped you?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_97",
      "title": "97"
    }
  }, [_vm._v("Do it! Try something challenging that neither of you has done before, like jumping on a giant trampoline, zip gliding, or swinging on a trapeze.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you rather throw a party or have a party thrown for you? Why?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you think it’s better to be the one who is loved more or the one who loves more? Why?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_98",
      "title": "98"
    }
  }, [_vm._v("Which art form do you enjoy doing more—writing, drawing, or making music? Would you share it publicly?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you could wave a magic wand and uninvent something that already exists, what object would you choose? How do you think it would change the world?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("When you’re traveling, either on a plane, bus, or train, are you likely to strike up a conversation with your seatmate? Or do you avoid making contact?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_99",
      "title": "99"
    }
  }, [_vm._v("Do you remember a time you felt so sick you thought you were dying?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What tempts you most but you can usually successfully resist?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Mini Quiz")]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("How would you rate your dance fever?")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Cool. You don’t have much interest in it, but you’ll boogie every now and then.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Warm. You like it mainly because it’s a turn-on.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Hot. Whenever you hear the beat, you start moving.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_100",
      "title": "100"
    }
  }, [_vm._v("Would you prefer to travel around the country or overseas? What’s your thinking?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How often do you tell little white lies? Do you remember the last one you told?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What is one thing you learned yesterday?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Who is the most challenging person you know?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_101",
      "title": "101"
    }
  }, [_vm._v("Do it! Write a poem for each other.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How would you define the concept of “sin”?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s something you thought you would get done today, but didn’t get around to doing?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Is it difficult for you to spend time alone or is it something you prefer?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_102",
      "title": "102"
    }
  }, [_vm._v("How do you explain the cycle of birth and death?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Is ignorance bliss? If yes, why? If no, why not?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What was the most dangerous situation you were ever in? How did you react? And do you think you have PTSD from it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you define “true love”?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_103",
      "title": "103"
    }
  }, [_vm._v("What does the expression “still waters run deep” mean? And do you think it’s true?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you think it’s better to live in one place or to move around?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you always rely on your GPS, or do you usually trust your own sense of direction when driving?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What is your mobile ring tone? Why did you choose it? How often do you change it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_104",
      "title": "104"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("At the end of your work day, do you usually feel:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Happy and satisfied.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Glad that you can go out and have fun.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Exhausted and desperate to de-stress and relax.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Are you more concerned with your weight, your finances, or your sexual prowess? What are you doing to improve in this area?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you feel poised for a change or pretty much steady with your pedal to the metal?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_105",
      "title": "105"
    }
  }, [_vm._v("Do you consider yourself to be a visionary? If so, in what ways? If not, are you more likely to rely on someone else’s view? If so, who is this person, and what does he or she have that you don’t?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Are you more likely to make excuses in order to get out of appointments or do you stick to honesty as a general rule?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("In what ways do you think men and women communicate differently?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_106",
      "title": "106"
    }
  }, [_vm._v("How much confidence do you have in the conventional medical establishment?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What do you think the planet needs most now—hope, peace, faith, or something else? Can you explain?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Describe your childhood family dinners. Was the family together on most evenings? Did you sit in the same seat every night? What sort of discussions (if any) did you have? Was it usually peaceful or contentious?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_107",
      "title": "107"
    }
  }, [_vm._v("Do you think you’re too hard on yourself? Or too easy? In what ways?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you believe you waste too much time? If so, in what ways? If not, how do you honor your time?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("In what ways do you think you’re dishonest with yourself?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_108",
      "title": "108"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("If you suddenly inherited a large sum of money, you would:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Quit your job and see the world.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Take up some kind of work that you’ve always wanted to do even though it doesn’t pay much.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Continue what you’re doing. You love your career.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Who’s the most important person in your life right now?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Are you more likely to confide your troubles and fears or do you usually keep those kinds of things to yourself?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_109",
      "title": "109"
    }
  }, [_vm._v("In what ways would you like your relationship to be like your parents’, and in what ways would you definitely want it to be different?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever considered killing yourself, even if it was just a momentary thought? What triggered such a consideration as brief as it might have been?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Play a classic board game like chess, checkers, Scrabble, or Monopoly.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What about your childhood do you most miss?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_110",
      "title": "110"
    }
  }, [_vm._v("Are you for or against fracking? Why? Why not?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you frequently judge others? Why do you think you do and how is it affecting your relationships?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you rather donate your time or your money to a worthy cause? Which do you think is more valuable?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_111",
      "title": "111"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("For your birthday, would you rather have:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Amnesia.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Dinner in your favorite restaurant with your loved one or family.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" A surprise party thrown in your honor.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What would make you stand up and cheer?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you experienced unrequited love? What did you learn from it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_112",
      "title": "112"
    }
  }, [_vm._v("Which trait do you believe attracts others to you the most: intellect, looks, or sense of humor?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you name five things about this country that you think are terrific? And five things that you believe need to be changed?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you go to a séance to contact someone you lost? Do you really believe it’s possible or are you doing it just out of curiosity?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_113",
      "title": "113"
    }
  }, [_vm._v("Do you prefer texting, calling, or emailing for communication? Why?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you could read anyone’s mind, whose would you choose and why?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Mini Quiz")]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Fantasies often take flight before a plane’s liftoff. While boarding, you usually think about:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Gliding gently onto the runway of your destination.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" A terrorist takeover or crash landing.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Sitting next to an interesting stranger.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_114",
      "title": "114"
    }
  }, [_vm._v("Let’s say you get a second chance on your life. What is the first thing you would do over?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What do you think is the most horrible sound in the world? The sweetest?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How do you feel about nostalgia? Good or bad?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What would someone have to do in order for you to ask him or her to leave a party you were hosting?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_115",
      "title": "115"
    }
  }, [_vm._v("Do it! Read the same book.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What was the last thing that happened to make you want to scream out loud (even though you kept your cool)?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What do you usually do when you can’t sleep at night?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s the first thing that comes to mind when you hear the word “unjust”?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_116",
      "title": "116"
    }
  }, [_vm._v("What’s the most disgusting food you’ve ever eaten—or tried to eat?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you describe a vacation that was anything but relaxing?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Who is the happiest person you know? Describe the way he or she expresses an upbeat attitude.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you name five personality traits that would turn you off a prospective partner? Which do you find the most offensive?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_117",
      "title": "117"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("If someone broke a promise made to you, would you most likely:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Bring their attention to it right then and there.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Be pissed in the moment, but let it go.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Be angry and carry a grudge for a while.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you usually overpack or underpack for a trip?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Make a playlist of your favorite romantic songs.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_118",
      "title": "118"
    }
  }, [_vm._v("What is a personal accomplishment that you’re especially proud of?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you were to write a Wikipedia entry, what subject would you choose?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Which do you think is unhealthier, marijuana or alcohol? Explain your position.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Approximately how many books a year do you read? What was the title of your most recent favorite and why did you like it so much?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_119",
      "title": "119"
    }
  }, [_vm._v("Is there any place on somebody’s body where a tattoo or piercing would really gross you out?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What would you like to do with your partner that you’ve never done before?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Mini Quiz")]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("The health food section of the store is offering some rather expensive goodies. You’re more likely to:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Treat yourself and buy the tastiest item.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Make do with a few samples.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Walk by—you don’t like to play with temptation.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_120",
      "title": "120"
    }
  }, [_vm._v("Do you think monogamy is really possible? Do you think it’s necessary in order to keep a relationship intimate and solid?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What five things do you think you should take less seriously? What five things do you think you should take more seriously?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What do you think about the power of eye contact?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Make out for ten minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_121",
      "title": "121"
    }
  }, [_vm._v("If you had to make a choice between being super-healthy and super-hot, which would you choose and why?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How do you think drunk drivers who cause serious injuries or death should be punished? What’s your reasoning?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you were given ten minutes to spend with the president of the United States, what would you want to talk about?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What acts of kindness were shown to you that you won’t ever forget?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_122",
      "title": "122"
    }
  }, [_vm._v("Do you think really rich people are happier? Why or why not?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you name five things you dislike about committed relationships? And five things you enjoy?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you think your partner truly trusts you? Why or why not?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s a good habit that if you could, you would develop starting today?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_123",
      "title": "123"
    }
  }, [_vm._v("Can you think of a circumstance that would lead you to betray a friend?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s the biggest skeleton in your family’s closet?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you say you’re a pretty predictable person, or do you tend to be unpredictable? Offer an example.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Name three things that you feel you’re too old to do, and explain why.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_124",
      "title": "124"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("If you were in the mood for a leisurely drive, where would you head?")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Down a country road.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Around town.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" To the shopping mall.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you believe in capital punishment? Why or why not?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How important is weather to you? For example, would a rainy day stop you from strolling on the beach or a super-warm day prevent you from taking a hike?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_125",
      "title": "125"
    }
  }, [_vm._v("Would you rescue a dog from the pound that was on death row even though you weren’t planning on getting a pet?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Have a thumb war.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you think jealousy can be a healthy reaction or is it always destructive? Do you consider yourself a jealous person?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Ever had a threesome? Or thought about it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_126",
      "title": "126"
    }
  }, [_vm._v("What about competitiveness? Good or bad? Do you consider yourself a competitive person?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Did you ever overreact because of a misunderstanding on your end? What was it about? How did you make amends, or did you let it go without explanation or apology?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Has someone ever sworn you to secrecy, but either by accident or on purpose, you blabbed?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_127",
      "title": "127"
    }
  }, [_vm._v("Have you ever been punked? When and how?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you consider yourself to be an open book or are you pretty tough to get to know?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you think all human beings basically want the same things in life?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What does the expression “charity begins at home” mean to you?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_128",
      "title": "128"
    }
  }, [_vm._v("What’s your debt situation? If you don’t have any, what’s your budgeting secret? If you have debt, is it enough to keep you up at night, and what’s your plan, if any, to deal with it?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("In your opinion which is more of a virtue: kindness or honesty? Explain.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What do you think about opiate addiction? Is it the fault of the pharmaceutical industry or human weakness?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_129",
      "title": "129"
    }
  }, [_vm._v("Do it! Tickle each other until someone cries “Uncle!”")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s your definition of “spiritual”? Is that how you see yourself?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you binge watch without guilt?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Who would you most likely buy an impulse gift for?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_130",
      "title": "130"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("If you were at a dinner party and found yourself disagreeing with your host’s view, you would probably:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Still stress your view.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Keep the conversation pleasant, even if it means conceding.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Politely smile and nod but inwardly seethe.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("When you’re out for lunch with friends, are you more likely to pay your portion, split the bill evenly, or pick up the entire tab?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s your ideal leisurely Sunday afternoon?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_131",
      "title": "131"
    }
  }, [_vm._v("Do you believe in the practice of positive affirmations? If so, what are a few that you might tell yourself?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you have a strong preference for whether you’re holding the steering wheel or sitting in the passenger’s seat? Which is it and what’s your thinking?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Where’s the strangest place you had sex?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_132",
      "title": "132"
    }
  }, [_vm._v("Are you a thrill seeker? For example, do you opt for scary amusement park rides, ski the black diamond, mountain climb, ride motorcycles, etc.?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Are you more of an apologizer or do you tend to make excuses? Describe one time today or yesterday when you used either approach.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How can partners prevent themselves from becoming totally codependent? Offer four of your favorite tips.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_133",
      "title": "133"
    }
  }, [_vm._v("Who’s the best cook you know, and what’s their best dish?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s the most common compliment you receive? And what’s your usual response?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("You know the expression: To err is human and to forgive is divine. Do you believe any mistake has the potential to be forgiven? What was the most difficult time you had to conjure forgiveness?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_134",
      "title": "134"
    }
  }, [_vm._v("Would you be willing to do anything to save your relationship? Where would you draw the line?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What are your thoughts about palm reading?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Watch the sunrise or sunset together.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you prefer friends to text first before calling to see if it’s a good time to talk? Or would you rather just ignore the call when you’re busy? Or interrupt what you’re doing and take it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_135",
      "title": "135"
    }
  }, [_vm._v("Around how many times a day do you look in the mirror?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How often do you experience the blues?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you remember the day you first met your partner?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you rather ask questions or trust your instincts?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_136",
      "title": "136"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("When it comes to making love, would you describe yourself as the:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Initiator.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Mentor.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Follower.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you name five things you hate spending money on?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What other country would you like to live in for one year?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Are you more likely to be sarcastic or ironic?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_137",
      "title": "137"
    }
  }, [_vm._v("On a scale of one to ten, how sociable are you? Would you like to increase or decrease that number—or are you happy with your level of sociability?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever covertly read another person’s texts or emails? What was the circumstance that drove you to do it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you have an idea for a startup? Or an invention?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("When you’re apart from your partner, how often do you think about him or her?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_138",
      "title": "138"
    }
  }, [_vm._v("What’s your opinion about sleeping in separate beds? Is it ever a good idea or is it the road to romantic ruin?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you could trade places with anyone for a day, who would you choose?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you trust your partner to always tell the truth?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you want to live beyond a hundred years? Why or why not?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_139",
      "title": "139"
    }
  }, [_vm._v("If you could afford either a cook, masseur, chauffeur, maid, or fitness trainer, who would you hire?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How is the paper money in your wallet arranged? In the same vein, what do you think about the philosophy that contends respecting your money (even in this way) means you’ll acquire more?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Hey, is money the root of all that’s evil?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Has anyone ever accidentally seen you naked?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_140",
      "title": "140"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("If your partner asked whether you liked a shirt he or she was wearing and you didn’t, would you probably:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Tell the honest truth so it won’t be worn again.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Sugarcoat your opinion by stressing the positive.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Offer a white lie and say, “You look great!”")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("When speaking with people in authority are you usually more anxious or defiant?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you think you’re sort of lazy?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_141",
      "title": "141"
    }
  }, [_vm._v("Would you rather spend the day with someone who liked to engage in big philosophical issues or someone who just wanted to hang out and have fun?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Raise a glass and make a toast to your partner.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you had to give up either sweet or spicy foods, which would you choose? And how much of a sacrifice would it be?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you think you say “I love you” too often or not often enough? Why is that?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_142",
      "title": "142"
    }
  }, [_vm._v("If your partner said something that wasn’t true in front of another couple, what would you do?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s more important to you: the way your lover smells or the way they feel?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How would you describe your face?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you have a childhood nickname that only a few people use now? Who are those folks?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_143",
      "title": "143"
    }
  }, [_vm._v("What do you think are the special abilities that make an expert flirt?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("When you’re having an argument, do you find yourself focusing more on getting your opinion across or keeping the situation under control?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you think pride is a good thing? Why or why not?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Were you a cool kid when you were growing up or more of a geek or nerd?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_144",
      "title": "144"
    }
  }, [_vm._v("What’s the worst travel experience you ever had?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What are you most ashamed of?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Who is someone you wish you never met?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What would you like to do on a rainy Sunday afternoon?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_145",
      "title": "145"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("If the person ahead of you on the supermarket express aisle had many more than the items allotted, would you:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Suggest he or she move to a regular line.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Say nothing.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Go to another line.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What do you consider your greatest accomplishment?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What would you do if you discovered a close relative was addicted to heroin or another drug?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_146",
      "title": "146"
    }
  }, [_vm._v("Do you remember a nightmare medical experience?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you sometimes get paranoid that you’re going to lose your job?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you think tidiness is a sign that a person isn’t creative? Or is it an indication of competence?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What are three things you feel absolutely neutral about?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_147",
      "title": "147"
    }
  }, [_vm._v("If you wrote a book, whom would you name in the dedication?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you remember the last time you cried?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Everything happens for a reason. Why do you think you met your partner?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What was the best party you ever went to?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Who was the most inspiring teacher you ever had?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_148",
      "title": "148"
    }
  }, [_vm._v("Do it! Work out together.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you were unsure of how to solve a problem, would you “sleep on it”?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What act could you perform in a circus?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What recent tragic news story touched you the deepest?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you accept a dare? Where might you draw the line?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_149",
      "title": "149"
    }
  }, [_vm._v("What is (or would be) your Twitter username?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you be more likely to place a bet at a poker table or buy a lottery ticket?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you still want to be with your partner if he or she looked completely different?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How would you be likely to react if someone spilled wine on your lap?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you speak to strangers in elevators?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_150",
      "title": "150"
    }
  }, [_vm._v("Are you a dedicated recycler?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you pick your nose?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s your definition of a narcissist?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Should a television be kept in the bedroom?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you rather read a book or play a video game?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_151",
      "title": "151"
    }
  }, [_vm._v("What’s your favorite work of art?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("When you travel, do you prefer to settle in one place, or explore several different locations?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you prefer a hot climate or a cold climate?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How many friends do you have outside of your own race?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_152",
      "title": "152"
    }
  }, [_vm._v("Do you enjoy spending time with children?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("When you enter a home where artificially scented products are used, are you sensitive to it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("When was the last time you cleaned the inside of your kitchen trash bin?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you correct people’s grammar or pronunciation?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_153",
      "title": "153"
    }
  }, [_vm._v("What are two things you feel competent to teach others?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Are you an interrupter?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever stolen a coworker’s idea and taken credit for it? Or has that happened to you?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you do your own taxes?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you operate a power tool?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_154",
      "title": "154"
    }
  }, [_vm._v("Are you able to control your thoughts much of the time?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you dress to express yourself, or do you dress to blend in?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you tell someone you loved him or her if you’d only known the person for a week?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever posed nude?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you believe self-improvement is an ongoing process?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_155",
      "title": "155"
    }
  }, [_vm._v("Would you rather cook or clean?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Could you help with an assisted suicide for somebody who is terminally ill and in pain?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How comfortable are you around very old people?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Are you more of a sports spectator or a participant?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you write poetry?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_156",
      "title": "156"
    }
  }, [_vm._v("Do you have more in assets than you owe in debt?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Were you big “trouble” as a teenager?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How do you react to know-it-alls?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever spread a rumor?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you know any magic tricks?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_157",
      "title": "157"
    }
  }, [_vm._v("Would you twerk?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you usually get your shoes repaired or do you discard them?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Offer a foot massage.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever stomped out of a room in anger?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How do you feel about clowns?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_158",
      "title": "158"
    }
  }, [_vm._v("Would you go to a foreign film?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Are you more of a penny pincher or someone who spends freely?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How often do you see your extended family?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you go to Burning Man?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you enjoy camping out?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_159",
      "title": "159"
    }
  }, [_vm._v("Would you say you were born in the wrong decade?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("On average, how much time do you spend grooming before leaving your house in the morning?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever worked for a political candidate or spoken strongly about one you supported?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Does it matter to you if a room has fluorescent lighting?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_160",
      "title": "160"
    }
  }, [_vm._v("How many pictures of yourself do you have displayed in your home?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you enter a dance contest?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What sparks your competitive spirit?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you let your gas tank reach “E” frequently or are you more likely to be sure to have at least a quarter of the tank filled?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("When you’re not feeling well, do you prefer to be fussed over or left alone?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_161",
      "title": "161"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("If you were served cool soup or coffee at a restaurant, would you be more likely to:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Send it back.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Leave it untouched.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Drink it anyway.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What was your best subject in high school? Are you still interested in it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How often do you look at your photos either on your mobile phone or computer? And how often do you change your screensavers?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_162",
      "title": "162"
    }
  }, [_vm._v("If you had to let just one person know your every feeling and every thought for a day, who would you choose that person to be? And why?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("When you hear about yet another mass shooting, what is usually your first reaction? Your second?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you’re an overnight guest at someone’s house, would you be more likely to offer to cook, buy something for dinner (including alcohol), or take your host out for a meal?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_163",
      "title": "163"
    }
  }, [_vm._v("What would you do (or say) if someone insulted your partner when he or she wasn’t present?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s the very first memory you can recall?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever witnessed a violent act such as a physical fight, robbery, or murder?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Why do you think so many Americans have drug problems?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_164",
      "title": "164"
    }
  }, [_vm._v("What was the absolute worst sexual experience you had in your life?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What would you do if you felt as if your best friend was pulling away from you?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you share your usual weekday routine from the time you wake up to the time you tuck in?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Compose a love letter.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_165",
      "title": "165"
    }
  }, [_vm._v("Have you ever performed in a talent show? What was your act?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How do you imagine a close brush with death would change you?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Mini Quiz")]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Are you more likely to be envious of another’s:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Physical appearance.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Career accomplishments.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Stuff.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_166",
      "title": "166"
    }
  }, [_vm._v("What’s the worst investment you ever made? The best?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What do you think is particularly admirable about the younger generation?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What book had the biggest impact on you?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s your favorite animated movie of all time?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Manicure or pedicure?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_167",
      "title": "167"
    }
  }, [_vm._v("What are four qualities you most admire in your best friend?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How would you feel about your partner going on a month-long holiday without you?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Let’s say you could safely grab five things from a burning house. What would those items be?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you describe a situation that brings out your feelings of insecurity?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_168",
      "title": "168"
    }
  }, [_vm._v("What are three ways men are discriminated against?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What are three ways women are discriminated against?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Mini Quiz")]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("What’s the first question you ask yourself when choosing something to wear for a business event?")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Is it comfortable?")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Does it make me look powerful?")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Is it appropriate for the situation?")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_169",
      "title": "169"
    }
  }, [_vm._v("What could a friend do that under no circumstances would you be able to forgive?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you knew someone who was a complete “sponge” and always taking, taking, taking but never giving, could you still be friends? Why or why not?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How often do you weigh yourself? If it’s frequently, does it affect your eating choices?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What are two things you won’t leave your home without?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_170",
      "title": "170"
    }
  }, [_vm._v("You’re working under a tight work deadline and every minute counts when your friend calls with a problem that needs to be solved immediately. Do you stop what you’re doing? Why or why not?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What do you think the saying “Smile and the world smiles with you” means?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you saw a stranger littering, would you say something, pick up the discarded trash and put it in a bin, or more likely just walk by?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you usually drive the speed limit, over the speed limit, or slightly under?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_171",
      "title": "171"
    }
  }, [_vm._v("Would you pick up a hitchhiker? What’s your reasoning?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What is your least favorite dessert? Your favorite? Is there any sweet you just won’t eat?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What would you do if someone were talking in a movie theater and disturbing your experience, as well as probably others in the audience?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Where do you stand on gun control?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_172",
      "title": "172"
    }
  }, [_vm._v("Do you have a packed bag in case of an emergency? If so, what’s in it? If not, do you ever think about creating one—or do you feel it’s a waste of time and effort?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What are three jobs you definitely couldn’t do?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you remember a time when you were disappointed because you weren’t chosen for something?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s your dieting philosophy?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_173",
      "title": "173"
    }
  }, [_vm._v("If you were lost, would you ask a stranger for directions, or would you rather spend time figuring out where to go, trusting you’ll eventually get to your destination?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you rather hike up a steep mountain, walk through a dessert, or swim across a big lake?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Other than buying food, do you do more of your purchasing over the Internet or in brick-and-mortar stores?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_174",
      "title": "174"
    }
  }, [_vm._v("What do you think about boycotting a product if you disagree with its company’s policies? Have you ever done it?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s your thinking on the transgender bathroom issue?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you prefer to wear solids or prints (including plaids)?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Who do you think was the best president, alive or dead? Why? And who was the worst?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_175",
      "title": "175"
    }
  }, [_vm._v("Would rather dance to a live band, a professional DJ, or your own playlist?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Which spectator sport would you enjoy seeing the most?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you remember a time in your childhood when you felt as if you were in danger?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If someone was pursuing you romantically but you couldn’t care less, how would you communicate your disinterest?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_176",
      "title": "176"
    }
  }, [_vm._v("What kind of volunteer work would you choose to do?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you think you have a healthy body image? In what ways yes and in what ways not so much?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Are you someone who easily burns bridges? Or are you more into repairing the damage done?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you risk your life to save an animal?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_177",
      "title": "177"
    }
  }, [_vm._v("How do you feel about Valentine’s Day? An opportunity to express love and appreciation or a commercial holiday created by companies to make money?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you walk or ride a bike to raise funds for a charity if it means you have to ask friends and acquaintances to make a donation in your support?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Could you live with a roommate at this time in your life?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_178",
      "title": "178"
    }
  }, [_vm._v("Are you close friends with anyone who has completely different political views than you?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you curse a lot? A little? Not at all?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s your opinion of Kickstarter campaigns?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How would you describe your handshake? Strong? Firm? Warm? Soft?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_179",
      "title": "179"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Which of these behaviors do you think offers the most memorable impression when interviewing for a job?")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Making frequent eye contact and smiling when speaking.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Asking insightful questions, including one personal question about the interviewer.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Following up with a phone call or sending a thank you email.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("On an average day, how much time do you spend in bed?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you prefer to work in silence or with music in the background?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_180",
      "title": "180"
    }
  }, [_vm._v("Do you think you’re more motivated by achievement or recognition? Can you give an example?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If your partner was gaining a lot of weight and you were concerned for health reasons, how would you approach the subject?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How much do you worry about what people think of you?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What are you usually doing on Saturday mornings?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_181",
      "title": "181"
    }
  }, [_vm._v("Are you more of a collaborator or an independent creator? Can you give an example of the last time you either took the lead or joined others?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Which game of chance would you most enjoy playing? When was the last time you did it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Who would you rely on more for advice—an astrologer, psychologist, or good friend?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How would you describe your handwriting?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_182",
      "title": "182"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("You’re planning to tackle a big project when something fun comes up. You:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Reschedule your project and have fun.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Get at least half done, then leave.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Finish the project completely before you go out.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How do you feel about unexpected guests showing up at your door?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("On the whole, what do you think about our justice system?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_183",
      "title": "183"
    }
  }, [_vm._v("Would you rather have your desk facing a window, door, or wall—and why?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What quality do you think is most important in a friend: shared values, reliability, or an upbeat outlook?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever had a premonition that came true?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What are usually the first thoughts that come to you when you wake in the morning?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_184",
      "title": "184"
    }
  }, [_vm._v("Do it! Mirror gaze. Standing in front of the same mirror, stare at each other’s reflection for a few minutes.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What do you think is the likelihood that a couple who breaks up and gets back together will have a lasting relationship?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Mini Quiz")]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Which of these reality shows would you be most likely to watch?")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" The Bachelor or The Bachelorette")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Keeping Up with the Kardashians")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" The Voice")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_185",
      "title": "185"
    }
  }, [_vm._v("Do you usually go back to the same place for vacations or research and try something new?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("When there are mass shootings, is your first reaction usually to blame the gun industry, our mental health system, or the existence of evil? Explain your reasoning.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("When was the last time you bought an article of clothing?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What was the worst storm or other natural disaster you experienced?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_186",
      "title": "186"
    }
  }, [_vm._v("When you were growing up, what remedy did your mother offer for the common cold? Do you still use it today?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s your take on vegan diets?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Mini Quiz")]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("If stuck in traffic, you’d be most likely to:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Strategize another way to get where you’re going.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Look for a better lane and hope the traffic cleared up soon.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Put on your favorite music or talk show and relax.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_187",
      "title": "187"
    }
  }, [_vm._v("Shuffleboard or ping-pong?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What are three must-dos for a relationship to work?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What meal do you enjoy most?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you fake an orgasm?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How much attention do you pay to your posture?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_188",
      "title": "188"
    }
  }, [_vm._v("Do you get choked up at weddings?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("For dessert, would you be more likely to order a selection of fruits, cheeses, cookies, or sorbets?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Who’s the most authentically spiritual person you know?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How would you say the world has changed since 9/11?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_189",
      "title": "189"
    }
  }, [_vm._v("What’s the most serious injury you’ve ever suffered?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you rather visit India or China?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s the most romantic date you ever had?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would most of your friends describe you as self-confident or humble?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s the best way to earn a person’s respect?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_190",
      "title": "190"
    }
  }, [_vm._v("Who’s your favorite comedian?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do It! Draw a heart on the bathroom mirror for your partner.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you were going to sign up for a class with your partner, what would you take?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you could change one thing about the way you look, what would it be?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you try to overcome negative self-talk? If so, what techniques do you use?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_191",
      "title": "191"
    }
  }, [_vm._v("Using only one sentence, can you describe yourself?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What are three loathsome chores?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How important is it to you that people remember, pronounce, and spell your name correctly?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What are two pieces of advice you would give to all parents?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s your definition of peace?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_192",
      "title": "192"
    }
  }, [_vm._v("Do you believe the opposite sex communicates differently? In what ways?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("When do you feel the loneliest?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever been physically, sexually, or emotionally abused?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s your favorite place on earth?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_193",
      "title": "193"
    }
  }, [_vm._v("Do you think we live the life we imagine?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you encountered someone recently who just rubbed you the wrong way?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you could hire a decorator for the day, what room in your home would you want redone?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If money doesn’t bring happiness, what does?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_194",
      "title": "194"
    }
  }, [_vm._v("Can you give an example of wisdom as opposed to intelligence?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s the best way to earn a partner’s trust?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Describe your thinking around natural remedies. Effective or bogus?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s your feeling about one-night stands?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Where do you see yourself five years from now?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_195",
      "title": "195"
    }
  }, [_vm._v("Who’s more important in your life: friends or family?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you move a great distance for a job?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What do you think about polyamory (open relationships)?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How important do you think physical attractiveness is in a relationship?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_196",
      "title": "196"
    }
  }, [_vm._v("What was the first impression you had of me?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("In your opinion, does size matter?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What is the most expensive gift you’ve ever given?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever said “I love you” when you didn’t mean it? What was the circumstance?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_197",
      "title": "197"
    }
  }, [_vm._v("Have you ever driven drunk? How often? Ever gotten a ticket or gotten into an accident?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you like my friends? Who do you like the most? The least? Why?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s one word you would use to describe yourself?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How old were you when you went on your first date? Where did you go? Did you have any kind of sex?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_198",
      "title": "198"
    }
  }, [_vm._v("Who was your hero when you were a kid?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Imagine your best friend warns you that I’m bad news. What would you do?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What were your high school days like?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Challenge each other to a trivia match.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Are you more a dog person or a cat person?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_199",
      "title": "199"
    }
  }, [_vm._v("What are two quirky things about me that you like?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("In an ideal world, how often would we have sex?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you believe opposites attract? How do you think we’re different? How are we the same?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you tell me if I had bad breath, a piece of food on my face, or snot sticking out of my nose?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_200",
      "title": "200"
    }
  }, [_vm._v("Are you into playful S&M, including a little light bondage?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you name three things I do or say that make you feel especially loved?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What scares you the most about our relationship?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If money weren’t an issue, what would you be doing right now?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_201",
      "title": "201"
    }
  }, [_vm._v("What holidays do you enjoy celebrating, if any?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you think experiences with exes help or hinder us?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you be willing to bail me out if I had crushing debt? Do you have a limit?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you believe in spending money on life insurance? What’s your reasoning?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_202",
      "title": "202"
    }
  }, [_vm._v("Would you want to travel to another planet?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever had a crush on a teacher?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How important is having children to you?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s the best romantic advice you’ve ever gotten? What would be the best romantic advice you could give?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you like to talk dirty or hear dirty talk? Or is it a turn-off?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_203",
      "title": "203"
    }
  }, [_vm._v("Try reading my mind. What am I thinking right in this second?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you think some things are unforgivable? Like what?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Plans for the evening: Would you rather choose or have your partner do it? How come?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What would be your ideal ticket for president and vice president? What’s your thinking behind it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_204",
      "title": "204"
    }
  }, [_vm._v("What’s your opinion about May-December relationships? Cougars?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Is it possible to be too nice?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you had an entire day to spend at a beach resort, describe what you would do. Drink cocktails? Read in a chair? Ride the waves? Walk along the sand?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How important is it to remember names of people you meet? Do you remember a time when you blanked on an important intro?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_205",
      "title": "205"
    }
  }, [_vm._v("What was the grossest thing you ever did?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What would you think about someone who had to compromise his or her values in order to achieve something great?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Let’s say you’re enjoying a dinner party at a friend’s house and you find several hairs in your soup. What would you do?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you give to people who beg for money? If so, how often? What’s your reasoning?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_206",
      "title": "206"
    }
  }, [_vm._v("Is it difficult to say no if someone asks you for a favor?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever hung up or come very close to hanging up on someone because you were so angry? What were the circumstances?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s too serious to be joked about?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Share an extremely ripe fruit like a peach, plum, or strawberry with your partner.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_207",
      "title": "207"
    }
  }, [_vm._v("Do you think everyone should have to carry personal ID all the time?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If all your neighbors owned guns, would you feel more protected or less safe?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you embark on a passionate love affair if you knew down the road it would definitely end in heartbreak?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you could plan how you were going to die, what way would it be?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_208",
      "title": "208"
    }
  }, [_vm._v("Let’s say you were in charge of putting the likeness of a famous person on the ten dollar bill. Who would you choose?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you recall the last time you blurted out something you ended up regretting?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Mini Quiz")]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("On an average day, do you apologize to your partner:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Once or twice, if at all.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" About five times.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Between six and a dozen times.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_209",
      "title": "209"
    }
  }, [_vm._v("Do you consider yourself to be a dreamer or a realist?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you had to give up either your sense of sight, sound, or touch, which one would you choose?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you weren’t able to erase your online history, how would it affect your Internet use?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("How do you define the word “lovely”?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_210",
      "title": "210"
    }
  }, [_vm._v("Do it! Rap a love song.")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If someone went rummaging through your closet or drawers, what would be the most shocking, or at least surprising, thing they would find?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you think we should negotiate with terrorists in order to save hostages’ lives?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s the most valuable thing you’ve taken that wasn’t really yours?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_211",
      "title": "211"
    }
  }, [_vm._v("What are three of the worst things about being your gender? The best?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What flaw would be enough to cause a break-up?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do it! Give your partner a piggyback ride.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever masturbated in a public place?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s your secret prejudice?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_212",
      "title": "212"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("If your partner says something hurtful, are you more likely to:")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" Admit your feelings are hurt.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Offer a cold shoulder until your feelings heal.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Simply hope it doesn’t happen again.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What makes you feel the most insecure?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Would you still get married if your future spouse went blind?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What television show do you watch that you’re a little embarrassed about?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_213",
      "title": "213"
    }
  }, [_vm._v("What’s your biggest sin?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you recall a time when you lost your dignity?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What was the last intimate moment you ruined? And how did you do it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What haven’t you done sexually that you dream about doing?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_214",
      "title": "214"
    }
  }, [_vm._v("What do you often think about when you’re alone in your car?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you could make a law that’s not already on the books, what would it be?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s the greatest accomplishment of your life so far?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Have you ever slapped anyone? What were the circumstances?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_215",
      "title": "215"
    }
  }, [_vm._v("Mini Quiz")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Which of these statements best describes how up-to-the-minute your partner is on your life?")]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("a)")]), _vm._v(" On the same page.")])]), _vm._v(" "), _c('p', {
    staticClass: "alpha"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("b)")]), _vm._v(" Somewhere in the chapter.")])]), _vm._v(" "), _c('p', {
    staticClass: "alphax"
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("c)")]), _vm._v(" Rarely, if ever, opens the book.")])]), _vm._v(" "), _c('p', {
    staticClass: "imagek"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/border.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s the difference between having sex and making love?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you name something you’re glad you’ll never have to do again?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_216",
      "title": "216"
    }
  }, [_vm._v("Define “truth.”")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What’s your pet peeve?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Does spending time with others usually energize you or drain you?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you could write a note to your younger self offering advice, what would it be?")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_217",
      "title": "217"
    }
  }, [_vm._v("Do you think social media brings us closer together or isolates us more?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("If you witnessed someone spanking a child, would you say or do anything to try and stop it?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Do you believe the basic nature of humans is kindness? Give examples either way.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Is it easy or difficult for you to change your mind? Describe a time when it was difficult.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_218",
      "title": "218"
    }
  }, [_vm._v("Do you think the media controls public opinion?")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What three interests do you share with your colleagues or fellow students?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Can you recall a particularly memorable summer vacation when you were a kid?")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("What signals do you think your body language is sending out?")]), _vm._v(" "), _c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "18",
      "src": "images/common.jpg",
      "width": "70"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4523b341","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter001.vue
// module id = 78
// module chunks = 0